import { injectable } from "tsyringe";

@injectable()
export class HttpClient {
  public async get(url: string): Promise<Response> {
    return fetch(url, {
      method: "GET",
      mode: "cors",
    });
  }
}
